import { color } from '../../theme'

export const getContrastTextColor = (hexColorCode: string) => {
  const colorCode = hexColorCode.startsWith('#') ? hexColorCode.slice(1) : hexColorCode
  if (colorCode.length !== 6) {
    return color.palette.black
  }
  const r = parseInt(colorCode.slice(0, 2), 16)
  const g = parseInt(colorCode.slice(2, 4), 16)
  const b = parseInt(colorCode.slice(4, 6), 16)

  // NOTE - luminance based on the RGB value
  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b

  // NOTE - white text if the background is dark, black otherwise
  return luminance < 128 ? color.palette.white : color.palette.black
}
